
import { ref, Ref } from "vue";
import { dispatchError } from "../../utils/error_handling";
import store from "../../../repository/store/store";
import router from "@/routes";
import { disableBodyOverflow, enableBodyOverflow } from "../mixins";
import RegisterModal from "./RegisterModal.vue";
import ResetPassword from "./ResetPassword.vue";
import ModernInput from "../application/forms/modernInput.vue";
import { useRoute } from "vue-router";

export default {
  name: "LoginFormCirculo",
  components: { ModernInput, ResetPassword, RegisterModal },

  setup() {
    const name: Ref<string> = ref("");
    const password: Ref<string> = ref("");
    const isPasswordVisible: Ref<boolean> = ref(false);

    const route = useRoute();

    const onSubmit = async () => {
      try {
        await login();
        await loadUser();
        if (route.query.redirect) {
          await router.push(route.query.redirect as string);
        } else {
          await router.push({ name: "dashboard" });
        }
      } catch (e) {
        console.error(e);
        await dispatchError(e);
      }
    };

    const login = async (): Promise<void> => {
      try {
        await store.dispatch("authentication_module/login", {
          login: name.value,
          password: password.value
        });
      } catch (e) {
        console.error(e);
        throw e;
      }
    };

    const loadUser = async (): Promise<void> => {
      try {
        await store.dispatch("userProfile_module/loadUser");
      } catch (e) {
        console.error(e);
        throw e;
      }
    };

    const isSignupModalOpen: Ref<boolean> = ref(false);

    const onClickSignup = (): void => {
      openSignupModal();
      disableBodyOverflow();
    };

    const onCloseSignup = (): void => {
      closeSignupModal();
      enableBodyOverflow();
    };

    const openSignupModal = (): void => {
      isSignupModalOpen.value = true;
    };

    const closeSignupModal = (): void => {
      isSignupModalOpen.value = false;
    };

    const onClickForgetPassword = (): void => {
      openResetPassword();
      disableBodyOverflow();
    };

    const openResetPassword = (): void => {
      isSignupModalOpen.value = true;
    };

    const onCloseForgetPassword = (): void => {
      router.push({ name: "home" });
      enableBodyOverflow();
    };

    /** Function that makes the password visible or not. */
    function togglePassword() {
      isPasswordVisible.value = !isPasswordVisible.value;
    }
    return {
      name,
      password,
      isSignupModalOpen,
      isPasswordVisible,
      onSubmit,
      onClickSignup,
      onCloseSignup,
      onClickForgetPassword,
      onCloseForgetPassword,
      togglePassword
    };
  }
};
